import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

interface IAttributesReviewsProps {
  visible: boolean;
}

export const AttributesReviews = styled.div`
  display: ${(props: IAttributesReviewsProps) =>
    props.visible ? 'block' : 'none'};
  @media (min-width: ${breakpoints.md}) {
    display: block;
    margin-top: 3.125rem;
  }
`;

export const ParamProgressWrapper = styled.div`
  width: 50%;
  padding-right: 0.625rem;
`;

export const ParamValue = styled.div<{ newPdDesignEnabled: boolean }>`
  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          ${theme.typography.labelSmall400};
        `
      : css`
          font-size: 0.75rem;
          line-height: 1.2;
        `}
  width: 50%;
`;
